<p-confirmDialog /><app-card-content [border]="false" icon="pi pi-box" title="Recursos Materiais" subtitle="Recursos materiais cadastrados"
    ><div card-header><app-botao-acoes label="Ações" [iconPos]="EInconPos.LEFT" [items]="itensAcoes" [iconColumns]="2" [permissaoUf]="pessoa()?.uf ?? null" /></div>
    <app-custom-table
        [metadata]="metadata"
        [data]="linhasTabela()"
        [columnOrder]="colunaOrdem"
        [loading]="carregando()"
        [totalRecords]="linhas().length"
        [rows]="10"
        [showExpandButton]="true"
        [showActions]="true"
        [cardColumns]="2"
        [permissaoUf]="pessoa()?.uf ?? null"
    />
    <div class="flex justify-end mt-3 font-semibold">Total: {{ total }}</div></app-card-content
><p-dialog appDialogoPadrao="pi pi-book" descricao="Equipamentos e instalações declarados." [(visible)]="editando" header="Recurso Material" [style]="{ width: 'min(94vw, 540px)' }" [appendTo]="'body'"
    ><form [formGroup]="form" class="flex flex-col gap-4">
        <div><label class="font-semibold block mb-2">Recurso</label><p-select fluid formControlName="idRecursoMaterial" [options]="tipos()" optionLabel="recursoMaterial" optionValue="idRecursoMaterial" appendTo="body" /></div>
        <div><label class="font-semibold block mb-2">Quantidade</label><p-inputNumber fluid formControlName="quantidade" [min]="1" /></div>
    </form>
    <ng-template #footer><p-button label="Cancelar" text (click)="editando = false" /><p-button label="Salvar" icon="pi pi-check" [loading]="salvando()" (click)="salvar()" /></ng-template
></p-dialog>
